$('.custom-input-file input[type="file"]').on('change', function(){
	var value = $(this).val();
 	var parent = $(this).parent('.custom-input-file');
  	var output = parent.find('.output');
  
  	output.text(value);
  
  	$(this).blur()
});